import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import style from "./vtexApi.module.css";
import { BounceLoader } from "react-spinners";
import VtexItems from "./VtexItems/VtexItems";
import { getBatchVtex } from "../../../redux/actions/apiActions";
import Pagination from "../../../components/Paginate/paginate";

function VtexApi() {
  const dispatch = useDispatch();
  const { batchVtexSarkanyus, loading, paginate } = useSelector((state) => state.apiData);
  
  useEffect(() => {
    dispatch(getBatchVtex(1));
  }, [dispatch]);

    const handlePageChange = (page) => {
    dispatch(getBatchVtex(page)); // ⬅️ usamos el mismo action con page
  };

  return (
    <div className={loading ? style.shopifyApiContainerLoading : style.vtexApiContainer}>
      {loading ? (
        <BounceLoader className={style.spinner} color="#61a030" />
      ) : (
        <>
          <div className={style.vtexApiEncabezado}>
            <ul className={`${style.uLlist} nav row`}>
              {["Total Elementos", "Fecha de Inicio", "Fecha de fin", "Duración", "Estado", "Llamar ahora","Descargar CSV"].map((text, idx) => (
                <li key={idx} className="nav-item col">
                  <span className="nav-link">{text}</span>
                </li>
              ))}
            </ul>
          </div>
          <div>
             {batchVtexSarkanyus?.map((batch, idx) => (
              <VtexItems key={batch._id || idx} item={batch} />
            ))} 
          </div>
        </>
      )}
    <div>
          <Pagination paginate={paginate} isLoading={loading} onPageChange={handlePageChange} />
      </div>
    </div>
  );
}

export default VtexApi;
